<template>
    <div style="width: 728px; margin:0 auto; background-color: #fff; position: relative; border: 3px solid #efefef;">
        <img src="./i1.png" style="width: 100%;"/>

        <div style="padding: 20px;">
            <item
                    number="1"
                    title="Проблемы гомеопатии: история, вызовы, современное состояние"
                    avtor="Джен Грин"
                    year="2004"
                    code="363.192 ГРИ"
                    search="медицина (3) ; генетически (2) ; гомеопатия (2) ; народная медицина (3) ; вещество (1)"
                    seria="Вопросы медицины"
                    theme="народная медицина">
                Разъясняет проблемы связанные с гомеопатическими средствами лечения, повествует о химическом составе гомеопатических препаратов и их отличии от препаратов с полным содержанием действующего вещества, касается критических возражений против гомеопатии как способа лечения - Содержит индекс... – Что такое гомеопатия? Когда появилась гомеопатия?
            </item>

            <item
                    number="2"
                    title="Отчет о проведении экспериментов с гомеопатическими препаратами с двумя контрольными группами"
                    avtor=""
                    year="2004"
                    code="363.192 НОВ"
                    search="медицина (2) ; продукция (1) ; здоровье (1) ; эксперимент (1)"
                    seria=""
                    theme="медицина, фармакология, исследования">
                Местная правительственная комиссия по охране здоровья. Отчет  1.9А…октя6рь 2004.
            </item>

            <item
                    number="3"
                    title="Заговор фармацевтических компаний | Опасность употребления лекарств – международное разоблачение"
                    avtor="Голден Джефри Александер"
                    year="2003"
                    code="631.5233 СМИ"
                    search="иллюзия (2); союз (2); гомеопатия (1); ложь (3); медицина (1) "
                    seria=""
                    theme="научно-популярная литература">
                … необходимо принять простую идею, а именно: правительства и государства заинтересованы в любых препаратах, произведенных глобальными транснациональными игроками, они вступают в сговор. - Предисловие Вступление Гл. 1… - Урок из-за границы Гл. 1
            </item>

            <item
                    number="4"
                    title="Забудьте о мега-дозировках лекарств | Почему нас заставляют глотать таблетки"
                    avtor="Иврен Дустен"
                    year="1998"
                    code="363.192 НОТ"
                    search="лекарства (2) ; таблетки (1) ; фармакология (1)"
                    seria=""
                    theme="научно-популярная литература">

            </item>

            <item
                    number="5"
                    title="Возьмите здоровье в свои руки. Народная медицина 2.0."
                    avtor="Титчер Марк"
                    year="2005"
                    code="363.192 ШОУ"
                    search="народная медицина (2); переосмысление (1) ; гомеопатия (1) ; здоровый образ жизни (1)"
                    seria=""
                    theme="народная медицина, научно-популярная литература">
                Автор является лектором в Кентерберийском университете. Новая Зеландия.
            </item>

            <item
                    number="6"
                    title="Трюк гомеопатов, или почему гомеопатия не работает"
                    avtor="Жизель Олдэни"
                    year="2004"
                    code="363.192 НГУ"
                    search="гомеопатия (4) ; журналистика (1) ; исследование языка (1); интересы (1) "
                    seria=""
                    theme="журналистское расследование, научно-популярная литература">
                Жизель показывает в своей книге, как появлялся рынок гомеопатических препаратов и какие компании за этим скрываются. Уделяется внимание исследованию языка, языковых приемов гомеопатов, пытающихся убедить общественность в том, что гомеопатия действительно работает
            </item>

            <item
                    number="7"
                    title="Можем ли доверять народной медицине?"
                    avtor="Жеваль Домье"
                    year="2003"
                    code="363.192 ДЮВ"
                    search="медицина (1) ; народная медицина (1) ; исследование (1) "
                    seria=""
                    theme="научно-популярная литература ">

            </item>

            <item
                    number="8"
                    title="Фармакологический прорыв, гомеопатия и медицина XXI века"
                    avtor="Брайан Шмаефски"
                    year="2006"
                    code="660.6 ШМА"
                    search="гомеопатия (1); современная медицина (1) ; фармакология (1); "
                    seria="Фармакология в XXI веке"
                    theme="научно-популярная литература, журналистское расследование">

            </item>

            <item
                    number="9"
                    title="Миф о гомеопатии: почему мы должны задуматься об этом?"
                    avtor="Ганс Роберти"
                    year="2003"
                    code="363.7 KEH"
                    search="гомеопатия (1) ; народная медицина (1) ; фармакология (1); "
                    seria=""
                    theme="научно-популярная литература, фармакология">

            </item>

            <item
                    number="10"
                    title="Рынок здоровья. Международное исследование"
                    avtor="Петр Ионин"
                    year="2003"
                    code="Научная литература"
                    search="вопросы медицины (2) : исследование (1) : модифицированный (1)"
                    seria=""
                    theme="научное исследование, фармакология, экономика">
                Работа представляет собой исследование рынка фармакологии в странах Евросоюза, исследование касается рынка сбыта товаров ключевых фармакологических корпораций.
            </item>

        </div>

    </div>
</template>
<script>
    import item from './item'

    export default {
        components: {
            item
        }
    }
</script>
<style scoped></style>
